const ShippingPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-10 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Shipping Policy</h1>

      <p className="mb-4">
        Luxor Clothing processes orders within 1–3 business days after
        confirmation.
      </p>

      <p className="mb-4">
        Delivery timelines may vary based on location and courier service, but
        typically range between 5–7 business days.
      </p>

      <p>
        Shipping charges (if any) will be clearly mentioned during checkout.
      </p>
    </div>
  );
};

export default ShippingPolicy;